import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {PostMessageService} from '../../../shared/services/post-message.service';

@Component({
  selector: 'app-widget-home-page',
  templateUrl: './widget-home-page.component.html',
  styleUrls: ['./widget-home-page.component.scss']
})
export class WidgetHomePageComponent implements OnInit, OnDestroy {

  private isStoreLocatorWidgetSubscription: Subscription;

  constructor(private _postMessageService: PostMessageService,
              private _router: Router) { }

  ngOnInit(): void {
    this.isStoreLocatorWidgetSubscription = this._postMessageService.isStoreLocatorWidget().subscribe((isStoreLocatorWidget) => {
      if (isStoreLocatorWidget) {
        // redirect alla rotta contenente lo store locator
        this._router.navigate(['/store-locator-frame']);
      }
    });
  }
  
  ngOnDestroy(): void {
    this.isStoreLocatorWidgetSubscription?.unsubscribe();
  }

}
